// extracted by mini-css-extract-plugin
export var discard = "_49-3";
export var muiTooltipTooltip = "_49-5";
export var notificationBar = "_49-2";
export var saveButtonHoverSlotWrapper = "_49-4";
export var show = "_49-1";
export var spacer = "_49-0";